









import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin, isMobile } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';

const baseUrl = 'GH18D0926';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动主页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '活动简介',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};
  beforeRouteEnter(to: any, from: any, next: any) {
    if (!isMobile()) {
      // 跳转到pc
      window.location.href =
        process.env.VUE_APP_ENV_NAME === 'production'
          ? 'https://activity.cqcb.com/shangyou_activity/GH18D0926/'
          : 'https://testdev.cqcb.com/GH18D0926/';
    } else {
      next();
    }
  }
  beforeCreate() {
    if (!isMobile()) {
      // 跳转到pc
      window.location.href =
        process.env.VUE_APP_ENV_NAME === 'production'
          ? 'https://activity.cqcb.com/shangyou_activity/GH18D0926/'
          : 'https://testdev.cqcb.com/GH18D0926/';
    }
  }
  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '中国工会十八大重庆专题',
      url: location.href,
      subtitle: `中国工会十八大重庆专题`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '中国工会十八大重庆专题',
        subtitle: `中国工会十八大重庆专题`,
        image: cover,
      });
    }
  }
}
